import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { FileToDownload } from '@/models/user.model'

export default {
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  data () {
    return {
      listLogs: [],
      fileContent: '',
      loading: false,
      fileToDownload: new FileToDownload()
    }
  },
  methods: {
    async getLogs () {
      this.loading = true
      this.$store.dispatch('user/getLogs').then(
        response => {
          this.loading = false
          this.listLogs = response
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    },
    async getFileToDownload (documentToDownload) {
      this.fileToDownload.login = this.$store.state.user.user.login
      this.fileToDownload.keyFolder = documentToDownload.keyFolder
      this.fileToDownload.realFileNameToDownload = documentToDownload.absolutePath

      this.$store.dispatch('user/getFileToDownload', this.fileToDownload).then(
        response => {
          this.fileContent = window.atob(response)
          if ('msSaveOrOpenBlob' in navigator) {
            let byteNumbers = new Array(this.fileContent.length)
            for (var i = 0; i < this.fileContent.length; i++) {
              byteNumbers[i] = this.fileContent.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            window.navigator.msSaveOrOpenBlob(new Blob([byteArray]), documentToDownload.nomFichierTelecharge)
          } else {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = 'data:application/file;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(this.fileContent)
            hiddenElement.target = '_blank'
            hiddenElement.download = documentToDownload.nomFichierTelecharge
            document.body.appendChild(hiddenElement)
            hiddenElement.click()
            document.body.removeChild(hiddenElement)
          }
        },
        error => {
          this.errorMessage = error.response.data
        }
      )
    }
  },
  created () {
    if (!this.listLogs.length) {
      this.getLogs()
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Logs'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
